import { Prefs, Surface, SurfacePrefs } from "./types";

/**
 * The client surface this build represents. The Word/Outlook add-ins ship the same
 * preferences service with this constant overridden to "word" / "outlook".
 */
export const CURRENT_SURFACE: Surface = "web";

/** Current schema version of the preferences envelope. Bump when the shape changes. */
export const PREFS_VERSION = 1;

/** Single LocalStorage key holding the whole versioned envelope. */
export const PREFS_LOCAL_KEY = "jaasper.prefs";

/**
 * Whether preferences are WRITTEN back to the backend via `PUT /user/me/properties`
 * (see api/user.ts `updateMyProperties`). The backend now ships this dedicated,
 * owner-only, deep-merging endpoint, so writes round-trip through the account. On any
 * write failure the store falls back to LocalStorage silently.
 */
export const PREFERENCES_API_WRITE = true;

/** First-generation per-key storage from the initial clickdummy; imported once. */
export const LEGACY_FAVORITES_KEY = "jaasper.home.favorites";
export const LEGACY_LAST_CATEGORY_KEY = "jaasper.home.lastCategory";

export function emptySurfacePrefs(): SurfacePrefs {
  return { favorites: [] };
}

export function emptyPrefs(): Prefs {
  return { version: PREFS_VERSION, settings: {}, bySurface: {} };
}
